import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { useState, useEffect } from 'react'

export const obtenerEstrellas = (score) => {
  if (score > 9) return 3
  if (score > 7) return 2
  if (score >= 5) return 1
  return 0
}

const STAR_STYLES = `
  @keyframes star-pop {
    0%   { transform: scale(0) rotate(-45deg); opacity: 0; }
    45%  { transform: scale(1.9) rotate(18deg); opacity: 1; }
    65%  { transform: scale(0.88) rotate(-6deg); }
    82%  { transform: scale(1.22) rotate(3deg); }
    100% { transform: scale(1.12) rotate(0deg); }
  }
  @keyframes star-glow {
    0%, 100% { filter: drop-shadow(0 0 6px rgba(250,204,21,0.6)) drop-shadow(0 0 12px rgba(250,204,21,0.3)); }
    50%       { filter: drop-shadow(0 0 14px rgba(250,204,21,1))  drop-shadow(0 0 28px rgba(250,204,21,0.5)); }
  }
  @keyframes sparkle-out {
    0%   { transform: translate(0,0) scale(1.2); opacity: 1; }
    100% { transform: translate(var(--tx), var(--ty)) scale(0); opacity: 0; }
  }
  .star-popping {
    animation: star-pop 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  }
  .star-glowing {
    animation: star-glow 1.8s ease-in-out infinite;
  }
  .sparkle-dot {
    animation: sparkle-out 0.55s ease-out forwards;
  }
`

const SPARKLE_ANGLES = [0, 60, 120, 180, 240, 300]
const SPARKLE_COLORS = ['#fbbf24', '#ffffff', '#fde68a', '#fbbf24', '#ffffff', '#fde68a']

const Estrellas = ({ score = 0, className = '' }) => {
  const estrellas = obtenerEstrellas(score)
  const [lit, setLit] = useState([])
  const [popping, setPopping] = useState([])
  const [sparkling, setSparkling] = useState([])

  useEffect(() => {
    if (estrellas === 0) return
    let i = 0
    const interval = setInterval(() => {
      const star = i + 1
      setLit(prev => [...prev, star])
      setPopping(prev => [...prev, star])
      setSparkling(prev => [...prev, star])
      setTimeout(() => setPopping(prev => prev.filter(s => s !== star)), 720)
      setTimeout(() => setSparkling(prev => prev.filter(s => s !== star)), 580)
      i++
      if (i >= estrellas) clearInterval(interval)
    }, 350)
    return () => clearInterval(interval)
  }, [estrellas])

  return (
    <>
      <style>{STAR_STYLES}</style>
      <div className={`flex justify-center gap-x-5 ${className}`}>
        {[1, 2, 3].map((i) => {
          const isLit = lit.includes(i)
          const isPopping = popping.includes(i)
          const isSparkling = sparkling.includes(i)

          return (
            <div key={i} className="relative flex items-center justify-center w-12 h-12 md:w-14 md:h-14">
              {isSparkling && SPARKLE_ANGLES.map((angle, idx) => {
                const rad = (angle * Math.PI) / 180
                const dist = 30 + (idx % 2) * 10
                return (
                  <div
                    key={angle}
                    className="sparkle-dot absolute rounded-full pointer-events-none"
                    style={{
                      width: idx % 2 === 0 ? '7px' : '5px',
                      height: idx % 2 === 0 ? '7px' : '5px',
                      backgroundColor: SPARKLE_COLORS[idx],
                      '--tx': `${Math.cos(rad) * dist}px`,
                      '--ty': `${Math.sin(rad) * dist}px`,
                      animationDelay: `${idx * 18}ms`,
                      top: '50%',
                      left: '50%',
                      marginTop: '-3.5px',
                      marginLeft: '-3.5px',
                    }}
                  />
                )
              })}

              <FontAwesomeIcon
                icon={faStar}
                className={`text-4xl md:text-5xl ${
                  isLit ? 'text-yellow-400' : 'text-gray-200'
                } ${isPopping ? 'star-popping' : ''} ${isLit && !isPopping ? 'star-glowing' : ''}`}
                style={!isLit && !isPopping ? { transform: 'scale(0.88)', opacity: 0.6 } : undefined}
              />
            </div>
          )
        })}
      </div>
    </>
  )
}

export default Estrellas
